const list = [
  { type: "operator", display: "+", value: "+", label: "Plus" },
  { type: "operator", display: "-", value: "-", label: "Minus" },
  { type: "operator", display: "/", value: "/", label: "Divide" },
  { type: "operator", display: "*", value: "*", label: "Multiply" },
  { type: "operator", display: "(", value: "(", label: "Parentheses (" },
  { type: "operator", display: ")", value: ")", label: ") Parentheses" },
  { type: "operator", is_compare_operator: true, display: "<", value: "<", label: "Less Than", date_label: "Before" },
  { type: "operator", is_compare_operator: true, display: "<=", value: "<=", label: "LessOrEqual Than", date_label: "Before or Equal" },
  { type: "operator", is_compare_operator: true, display: ">", value: ">", label: "Greater Than", date_label: "After" },
  { type: "operator", is_compare_operator: true, display: ">=", value: ">=", label: "GreaterOrEqual Than", date_label: "After or Equal" },
  { type: "operator", is_compare_operator: true, display: "=", value: "==", label: "Equal To", date_label: "Exact date" },
  { type: "operator", is_compare_operator: true, display: "!=", value: "!=", label: "NotEqual To", date_label: "Not Exact date" },
  { type: "operator", is_compare_operator: true, display: "Not", value: "not", label: "Not" },
  { type: "operator", is_compare_operator: true, display: "And", value: "and", label: "And" },
  { type: "operator", is_compare_operator: true, display: "Or", value: "or", label: "Or" },
  { type: "operator", is_compare_operator: true, for: ["String"], display: "Includes", value: "in", label: "Includes" },
  { type: "operator", is_compare_operator: true, for: ["Number"], display: "In Range", value: "in", label: "In Range" },
  {
    type: "operator",
    is_compare_operator: true,
    for: ["Date", "DateTime"],
    display: "In Date Range",
    value: "in",
    label: "In Date Range",
    date_label: "In Date Range"
  },
  { type: "function", for: ["Number"], display: "MIN", value: "MIN", mapped_func: "min", label: "MIN" },
  { type: "function", for: ["Number"], display: "MAX", value: "MAX", mapped_func: "max", label: "MAX" },
  { type: "function", for: ["Number"], display: "SUM", value: "SUM", mapped_func: "sum", label: "SUM" },
  { type: "function", for: ["Number"], display: "AVG", value: "AVG", mapped_func: "sum", label: "AVG" },
  { type: "function", for: ["Number"], display: "WEIGHTED", value: "WEIGHTED", mapped_func: "weighted", label: "WEIGHTED" },
  { type: "function", display: "COUNT", value: "COUNT", mapped_func: "sum", label: "COUNT" },

  {
    type: "metrics",
    data_type: "String",
    name: "Owner",
    display: "Owner",
    reference_name: "owner__email",
    value: "owner__email",
    label: "Owner",
    options: []
  },
  {
    type: "metrics",
    data_type: "String",
    name: "Direct Parent",
    display: "Direct Parent",
    reference_name: "parent__id",
    value: "parent__id",
    label: "Direct Parent",
    options: []
  },
  {
    type: "field",
    data_type: "String",
    name: "Origin",
    display: "Origin",
    reference_name: "origins",
    value: "origins",
    label: "Origin",
    options: []
  },
  {
    type: "metrics",
    data_type: "String",
    name: "Top Parent",
    display: "Top Parent",
    reference_name: "top_parent__id",
    value: "top_parent__id",
    label: "Top Parent",
    options: []
  },
  {
    type: "forecast_metrics",
    data_type: "String",
    name: "Forecast Status",
    display: "Forecast Status",
    reference_name: "forecasts__forecast_status",
    value: "forecasts__forecast_status",
    label: "Forecast Status",
    options: [
      { value: "forecasted", label: "Forecasted" },
      { value: "actual", label: "Actual" }
    ]
  },
  {
    type: "forecast_metrics",
    data_type: "String",
    name: "Forecast Type",
    display: "Forecast Type",
    reference_name: "forecasts__forecast_type",
    value: "forecasts__forecast_type",
    label: "Forecast Type",
    options: [
      { value: "non-renewable", label: "Non-Renewable" },
      { value: "renewal", label: "Renewal" },
      { value: "expansion", label: "Expansion" },
      { value: "influx", label: "Influx" }
    ]
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Assigned tags",
    display: "Assigned tags",
    reference_name: "tags__name",
    value: "tags__name",
    label: "Assigned tags",
    options: [
      // filled by api
    ]
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Goals",
    display: "Goals",
    reference_name: "goals__id",
    value: "goals",
    label: "Goals",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Goal assigned to",
    display: "Goal assigned to",
    reference_name: "goals__assigned_to__email",
    value: "goals__assigned_to__email",
    label: "Goal assigned to",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Goal description",
    display: "Goal description",
    reference_name: "goals__description",
    value: "goals__description",
    label: "Goal description",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "DateTime",
    name: "Goal due date",
    display: "Goal due date",
    reference_name: "goals__due_date",
    value: "goals__due_date",
    label: "Goal due date",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Goal name",
    display: "Goal name",
    reference_name: "goals__name",
    value: "goals__name",
    label: "Goal name",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Goal status",
    display: "Goal status",
    reference_name: "goals__status",
    value: "goals__status",
    label: "Goal status",
    options: [
      { label: "Pending", value: "pending" },
      { label: "In-Progress", value: "in-progress" },
      { label: "Completed", value: "completed" },
      { label: "Missed", value: "missed" }
    ]
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Goal type",
    display: "Goal type",
    reference_name: "goals__type",
    value: "goals__type",
    label: "Goal type",
    options: [
      { label: "Specific", value: "specific" },
      { label: "Measurable", value: "measurable" },
      { label: "Time-Bound", value: "time-Bound" }
    ]
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Tasks",
    display: "Tasks",
    reference_name: "tasks__id",
    value: "tasks",
    label: "Tasks",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Task assigned to",
    display: "Task assigned to",
    reference_name: "tasks__assigned_to__email",
    value: "tasks__assigned_to__email",
    label: "Task assigned to",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Task description",
    display: "Task description",
    reference_name: "tasks__description",
    value: "tasks__description",
    label: "Task description",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "DateTime",
    name: "Task due date",
    display: "Task due date",
    reference_name: "tasks__due_date",
    value: "tasks__due_date",
    label: "Task due date",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Task name",
    display: "Task name",
    reference_name: "tasks__name",
    value: "tasks__name",
    label: "Task name",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Task priority",
    display: "Task priority",
    reference_name: "tasks__priority",
    value: "tasks__priority",
    label: "Task priority",
    options: [
      { label: "Lowest", value: "lowest" },
      { label: "Low", value: "low" },
      { label: "Normal", value: "normal" },
      { label: "High", value: "high" },
      { label: "Highest", value: "highest" }
    ]
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Task status",
    display: "Task status",
    reference_name: "tasks__status",
    value: "tasks__status",
    label: "Task status",
    options: [
      { label: "Pending", value: "pending" },
      { label: "In-Progress", value: "in-progress" },
      { label: "Completed", value: "completed" },
      { label: "Canceled", value: "cancelled" }
    ]
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Plans",
    display: "Plans",
    reference_name: "plans__id",
    value: "plans",
    label: "Plans",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Plan collaborators",
    display: "Plan collaborators",
    reference_name: "plans__collaborators__email",
    value: "plans__collaborators__email",
    label: "Plan collaborators",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Plan description",
    display: "Plan description",
    reference_name: "plans__description",
    value: "plans__description",
    label: "Plan description",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "DateTime",
    name: "Plan due date",
    display: "Plan due date",
    reference_name: "plans__due_date",
    value: "plans__due_date",
    label: "Plan due date",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Plan name",
    display: "Plan name",
    reference_name: "plans__name",
    value: "plans__name",
    label: "Plan name",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "DateTime",
    name: "Plan start date",
    display: "Plan start date",
    reference_name: "plans__start_date",
    value: "plans__start_date",
    label: "Plan start date",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Plan status",
    display: "Plan status",
    reference_name: "plans__status",
    value: "plans__status",
    label: "Plan status",
    options: [
      { label: "Pending", value: "pending" },
      { label: "In-Progress", value: "in-progress" },
      { label: "Completed", value: "completed" },
      { label: "Missed", value: "missed" }
    ]
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Plan type",
    display: "Plan type",
    reference_name: "plans__type",
    value: "plans__type",
    label: "Plan type",
    options: [
      { label: "Account Plan", value: "account_plan" },
      { label: "Growth Plan", value: "growth_plan" },
      { label: "Success Plan", value: "success_plan" },
      { label: "Onboarding Plan", value: "onboarding_plan" },
      { label: "Health Plan", value: "health_plan" },
      { label: "Renewal Plan", value: "renewal_plan" },
      { label: "Other", value: "other" }
    ]
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Interactions",
    display: "Interactions",
    reference_name: "interactions__id",
    value: "interactions",
    label: "Interactions",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Interaction category",
    display: "Interaction category",
    reference_name: "interactions__category",
    value: "interactions__category",
    label: "Interaction category",
    options: [
      { label: "Renewal", value: "renewal" },
      { label: "Support", value: "support" },
      { label: "Expansion", value: "expansion" },
      { label: "Onboarding", value: "onboarding" },
      { label: "Business Review", value: "business_review" },
      { label: "Business", value: "business" },
      { label: "Consultation", value: "consultation" },
      { label: "Training", value: "training" },
      { label: "QBR", value: "qbr" },
      { label: "EBR", value: "ebr" },
      { label: "Ticket", value: "ticket" },
      { label: "Chat", value: "chat" },
      { label: "In-app", value: "in-app" },
      { label: "Webinar", value: "webinar" },
      { label: "Campaign", value: "campaign" },
      { label: "Inbound", value: "inbound" },
      { label: "Resources", value: "resources" },
      { label: "Website", value: "website" },
      { label: "Other", value: "other" }
    ]
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Interaction description",
    display: "Interaction description",
    reference_name: "interactions__description",
    value: "interactions__description",
    label: "Interaction description",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "DateTime",
    name: "Interaction date",
    display: "Interaction date",
    reference_name: "interactions__interaction_date",
    value: "interactions__interaction_date",
    label: "Interaction date",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Interaction name",
    display: "Interaction name",
    reference_name: "interactions__name",
    value: "interactions__name",
    label: "Interaction name",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Interaction origin",
    display: "Interaction origin",
    reference_name: "interactions__origin",
    value: "interactions__origin",
    label: "Interaction origin",
    options: [
      { label: "Salesforce", value: "salesforce" },
      { label: "HubSpot", value: "hubspot" },
      { label: "Platform User", value: "platform_user" },
      { label: "SpreadSheet", value: "spreadsheet" },
      { label: "Platform Maps", value: "platform_maps" },
      { label: "Gmail", value: "gmail" },
      { label: "Outlook", value: "outlook" }
    ]
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Interaction type",
    display: "Interaction type",
    reference_name: "interactions__type",
    value: "interactions__type",
    label: "Interaction type",
    options: [
      { label: "Note", value: "note" },
      { label: "Meeting", value: "meeting" },
      { label: "In Person Meeting", value: "in_person_meeting" },
      { label: "Call", value: "call" },
      { label: "Email", value: "email" },
      { label: "Support", value: "support" },
      { label: "Marketing", value: "marketing" },
      { label: "Other", value: "other" }
    ]
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Phase description",
    display: "Phase description",
    reference_name: "phases__description",
    value: "phases__description",
    label: "Phase description",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Phase name",
    display: "Phase name",
    reference_name: "phases__name",
    value: "phases__name",
    label: "Phase name",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Funnel description",
    display: "Funnel description",
    reference_name: "funnels__description",
    value: "funnels__description",
    label: "Funnel description",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "String",
    name: "Funnel name",
    display: "Funnel name",
    reference_name: "funnels__name",
    value: "funnels__name",
    label: "Funnel name",
    options: []
  },
  {
    type: "other_metrics",
    data_type: "Boolean",
    name: "Funnel is public",
    display: "Funnel is public",
    reference_name: "funnels__is_public",
    value: "funnels__is_public",
    label: "Funnel is public",
    options: []
  },

  {
    type: "forecast_metrics",
    data_type: "Number",
    input_options: { max: 1, min: 0, step: "0.01", pattern: "\\d+" },
    name: "Forecasted GRR",
    display: "Forecasted GRR",
    reference_name: "forecasts__grr",
    value: "forecasts__grr",
    label: "Forecasted GRR"
  },
  {
    type: "forecast_metrics",
    data_type: "Number",
    input_options: { min: 0 },
    name: "Forecasted NRR",
    display: "Forecasted NRR",
    reference_name: "forecasts__nrr",
    value: "forecasts__nrr",
    label: "Forecasted NRR"
  },
  {
    type: "forecast_metrics",
    data_type: "Number",
    name: "Forecasted Delta",
    display: "Forecasted Delta",
    reference_name: "forecasts__delta",
    value: "forecasts__delta",
    label: "Forecasted Delta"
  },
  {
    type: "forecast_metrics",
    data_type: "Number",
    name: "Forecasted Delta%",
    display: "Forecasted Delta%",
    reference_name: "forecasts__delta_percentage",
    value: "forecasts__delta_percentage",
    label: "Forecasted Delta%"
  },
  {
    type: "forecast_metrics",
    data_type: "Number",
    name: "Forecasted Churn Amount",
    display: "Forecasted Churn Amount",
    reference_name: "forecasts__churn_amount",
    value: "forecasts__churn_amount",
    label: "Forecasted Churn Amount"
  },

  {
    type: "forecast_metrics",
    data_type: "Number",
    name: "Forecasted Base Value",
    display: "Forecasted Base Value",
    reference_name: "forecasts__renewal_base_value",
    value: "forecasts__renewal_base_value",
    label: "Forecasted Base Value"
  },
  {
    type: "forecast_metrics",
    data_type: "Number",
    name: "Forecasted Value",
    display: "Forecasted Value",
    reference_name: "forecasts__forecasted_value",
    value: "forecasts__forecasted_value",
    label: "Forecasted Value"
  },
  {
    type: "forecast_metrics",
    data_type: "Number",
    name: "Forecasted Worst Value",
    display: "Forecasted Worst Value",
    reference_name: "forecasts__forecasted_value_min",
    value: "forecasts__forecasted_value_min",
    label: "Forecasted Worst Value"
  },
  {
    type: "forecast_metrics",
    data_type: "Number",
    name: "Forecasted Best Value",
    display: "Forecasted Best Value",
    reference_name: "forecasts__forecasted_value_max",
    value: "forecasts__forecasted_value_max",
    label: "Forecasted Best Value"
  },
  {
    type: "forecast_metrics",
    data_type: "Date",
    name: "Forecasted Date",
    display: "Forecasted Date",
    reference_name: "forecasts__forecasted_date",
    value: "forecasts__forecasted_date",
    label: "Forecasted Date"
  },

  // { type: "metric", data_type: "Number", name: "Renewal Base", display: "Renewal Base", reference_name: "renewal_base", value: "renewal_base", label: "Renewal Base" },
  // { type: "metric", data_type: "Date", name: "Renewal Date", display: "Renewal Date", reference_name: "renewal_date", value: "renewal_date", label: "Renewal Date" },

  { more: true, type: "function", for: ["Number"], display: "ABS", value: "ABS", mapped_func: "abs", label: "ABS" },
  { more: true, type: "function", for: ["Number"], display: "ACOS", value: "ACOS", mapped_func: "cos", label: "ACOS" },
  { more: true, type: "function", for: ["Number"], display: "ASIN", value: "ASIN", mapped_func: "sin", label: "ASIN" },
  { more: true, type: "function", for: ["Number"], display: "ATAN", value: "ATAN", mapped_func: "atan", label: "ATAN" },
  { more: true, type: "function", for: ["Number"], display: "ATAN2", value: "ATAN2", mapped_func: "atan", label: "ATAN2" },
  { more: true, type: "function", for: ["Number"], display: "CEIL", value: "CEIL", mapped_func: "ceil", label: "CEIL" },
  { more: true, type: "function", for: ["Number"], display: "COS", value: "COS", mapped_func: "cos", label: "COS" },
  { more: true, type: "function", for: ["Number"], display: "COT", value: "COT", mapped_func: "atan", label: "COT" },
  { more: true, type: "function", for: ["Number"], display: "DEGREES", value: "DEGREES", mapped_func: "degrees", label: "DEGREES" },
  { more: true, type: "function", for: ["Number"], display: "EXP", value: "EXP", mapped_func: "exp", label: "EXP" },
  { more: true, type: "function", for: ["Number"], display: "FLOOR", value: "FLOOR", mapped_func: "floor", label: "FLOOR" },
  { more: true, type: "function", for: ["Number"], display: "LN", value: "LN", mapped_func: "ln", label: "LN" },
  { more: true, type: "function", for: ["Number"], display: "LOG", value: "LOG", mapped_func: "log", label: "LOG" },
  { more: true, type: "function", for: ["Number"], display: "MOD", value: "MOD", mapped_func: "exp", label: "MOD" },
  { more: true, type: "function", for: ["Number"], display: "PI", value: "PI", mapped_func: "PI", label: "PI" },
  { more: true, type: "function", for: ["Number"], display: "POWER", value: "POWER", mapped_func: "pow", label: "POWER" },
  { more: true, type: "function", for: ["Number"], display: "RADIANS", value: "RADIANS", mapped_func: "radians", label: "RADIANS" },
  { more: true, type: "function", for: ["Number"], display: "RANDOM", value: "RANDOM", mapped_func: "random", label: "RANDOM" },
  { more: true, type: "function", for: ["Number"], display: "ROUND", value: "ROUND", mapped_func: "round", label: "ROUND" },
  { more: true, type: "function", for: ["Number"], display: "SIGN", value: "SIGN", mapped_func: "sign", label: "SIGN" },
  { more: true, type: "function", for: ["Number"], display: "SIN", value: "SIN", mapped_func: "sin", label: "SIN" },
  { more: true, type: "function", for: ["Number"], display: "SQRT", value: "SQRT", mapped_func: "sqrt", label: "SQRT" },
  { more: true, type: "function", for: ["Number"], display: "TAN", value: "TAN", mapped_func: "tan", label: "TAN" },
  { type: "cases", display: "If/then", value: "cases", label: "If/then", cases: [{ when: [], then: [] }] },
  { type: "date_extractor", for: ["Date", "DateTime"], display: "TimeDelta", value: "timedelta", label: "TimeDelta" },
  { type: "date_extractor", for: ["Date", "DateTime"], display: "Today", value: "today", label: "Today" },
  { type: "date_extractor", for: ["Date", "DateTime"], display: "DateYear", value: "DateYear", label: "DateYear" },
  { type: "date_extractor", for: ["Date", "DateTime"], display: "DateMonth", value: "DateMonth", label: "DateMonth" },
  { type: "date_extractor", for: ["Date", "DateTime"], display: "DateDay", value: "DateDay", label: "DateDay" },
  { type: "date_extractor", for: ["Date", "DateTime"], display: "DateQuarter", value: "DateQuarter", label: "DateQuarter" }
]

export default list
